/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// ui
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
// icons
import InfoIcon from '@material-ui/icons/Info';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import PrintIcon from '@material-ui/icons/Print';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
// utils
import moment from 'moment';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { appActions } from 'commons/reducer';
import { objectToQueryString } from 'utils/api';
import { getLocalDate } from 'utils/DateFormat';
import { withRouter } from 'react-router-dom';
import { Header } from 'commons/components/DataTable/Header';
import { useIsMobileDevice } from 'utils/hooks/isMobileDevice';
import { useAutomation } from 'utils/hooks/useAutomationPermission';
import { Row } from 'commons/components/DataTable/Row';
import {
  AccountCircleOutlined,
  AssignmentOutlined,
  CalendarTodayOutlined,
  HouseOutlined,
  LayersOutlined,
  LocalShippingOutlined,
} from '@material-ui/icons';
import { Box, Tooltip } from '@material-ui/core';
import saga from '../../saga';
import connectSaga from '../../../../utils/saga';
import { receiptsActions } from '../../reducer';
import { selectState, actionProps } from '../../../../utils/reduxActions';
import { clone, fNumber, getUnitDetails, truthty } from '../../../../utils/functions';
import SkeletonList from '../../../../commons/components/SkeletonList';
import CustomPagination from '../../../../commons/components/CustomPagination';
import { shouldUseCallOffInAutomationModals } from '../../../../utils/tenantFeatures';
import { getAccessPolicy, getCurrentSubdomain } from 'utils/accessPolicy';

function ItemList(props) {
  const {
    account,
    actions,
    classes,
    device,
    receiptIdList,
    loading,
    pagination,
    objects,
    inputSearch,
    anchorEl,
    handleClose,
    history,
    handleClick,
    headerList,
  } = props;
  const { t } = useTranslation();
  const { hasAutomation } = useAutomation();
  const accessPolicy = getAccessPolicy({
    subdomain: getCurrentSubdomain(),
    roleName: props.role?.name,
  });
  const shouldShowCallOffColumn =
    hasAutomation && shouldUseCallOffInAutomationModals();
  const {
    canEdit,
    canDelete,
    canPrint,
    canTraceability,
  } = accessPolicy.receipts;

  const { unitCode } = getUnitDetails(objects.accounts);

  const [receipts, setReceipts] = useState([]);
  const isMobileDevice = useIsMobileDevice();

  useEffect(() => {
    setReceipts(
      Object.values(objects.receipts)
        .filter((receipt) => receiptIdList?.includes(receipt.id))
        .sort((a, b) => b.id - a.id),
    );
  }, [objects.receipts, receiptIdList]);

  const handleChangeRowsPerPage = (e) => {
    actions.paginationControls(inputSearch, {
      ...pagination,
      rowsPerPage: e.target.value,
    });
  };

  const handleChangePage = (e, val) => {
    actions.paginationControls(inputSearch, { ...pagination, page: val });
  };

  const toggleEdit = () => {
    handleClose();
    const item = Object.values(objects.receipts).find(
      (itemI) => itemI.id === Number(anchorEl.dataset.id),
    );
    if (item) {
      const linkedLots = Object.values(objects?.lotReceiptLots || {})
        .filter((link) => link?.receiptLotId === item?.receiptLotId)
        .map((link) => objects?.lots?.[link?.lotId])
        .filter(Boolean);

      item._resolvedLots = linkedLots;
    }
    actions.toggleEdit(item);
  };
  const printFnc = () => {
    const receipt = Object.values(objects.receipts).find(
      (item) => item.id === Number(anchorEl.dataset.id),
    );
    const receiptLots = getReceiptLots(receipt);
    const labelData = {
      lotIds: receiptLots.map((l) => l.id),
      accountId: account?.id,
    };
    actions.printReceptionLabel(device, labelData, false);
  };

  const toggleTaceability = () => {
    handleClose();
    const receipt = objects.receipts[anchorEl.dataset.id];
    const receiptLotNumber = getReceiptLot(receipt)?.number;
    const receiptLots = getReceiptLots(receipt);
    const queryParams = {};

    if (hasAutomation && receiptLotNumber) {
      queryParams.lotNumber = receiptLotNumber;
    } else if (receiptLots.length) {
      queryParams.lotIds = receiptLots.map((lot) => lot.id);
    }

    const query = objectToQueryString(queryParams);

    if (!query) return;

    history.push(`lotTraceability?${query}`);
  };

  function toggleDelete() {
    handleClose();
    actions.toggleDelete(anchorEl.dataset.id);
  }

  const getOptions = (receipt) => (
    <IconButton onClick={handleClick} data-id={receipt.id}>
      <MoreVertIcon />
    </IconButton>
  );

  const getReceiptProcess = (receipt) =>
    (typeof receipt?.process === 'function' && receipt.process()) ||
    objects?.processes?.[receipt?.processId] ||
    null;

  const getReceiptLot = (receipt) =>
    (typeof receipt?.receiptLot === 'function' && receipt.receiptLot()) ||
    objects?.receiptLots?.[receipt?.receiptLotId] ||
    null;

  const getReceiptSupplier = (receipt) =>
    (typeof receipt?.supplier === 'function' && receipt.supplier()) ||
    objects?.suppliers?.[receipt?.supplierId] ||
    null;

  const getReceiptClient = (receipt) =>
    (typeof receipt?.client === 'function' && receipt.client()) ||
    objects?.clients?.[receipt?.clientId] ||
    null;

  const getEntityFromOwner = (owner) =>
    (typeof owner?.entity === 'function' && owner.entity()) ||
    objects?.entities?.[owner?.entityId] ||
    null;

  const getPaddockFromReceiptLot = (receiptLot) =>
    (typeof receiptLot?.paddock === 'function' && receiptLot.paddock()) ||
    objects?.paddocks?.[receiptLot?.paddockId] ||
    null;

  const getProcessDepartureLots = (process) => {
    if (!process) return [];
    if (typeof process?.departureLots === 'function') return process.departureLots() || [];
    return Object.values(objects?.lots || {}).filter((lot) => lot?.originProcessId === process?.id);
  };

  const getLotRelation = (lot, fnName, fallbackMap, fallbackIdField) =>
    (typeof lot?.[fnName] === 'function' && lot[fnName]()) ||
    fallbackMap?.[lot?.[fallbackIdField]] ||
    null;

  const getReceiptLots = (receipt) => {
    if (!receipt) return [];

    const directLots =
      (typeof receipt?.lots === 'function' && receipt.lots()) ||
      getProcessDepartureLots(getReceiptProcess(receipt));

    if (directLots?.length) return directLots;

    return Object.values(objects?.lotReceiptLots || {})
      .filter((link) => link?.receiptLotId === receipt?.receiptLotId)
      .map((link) => objects?.lots?.[link?.lotId])
      .filter(Boolean);
  };

  const getChipProduct = (receipt) => {
    const [lot] = getReceiptLots(receipt);
    if (lot) {
      const fruit = getLotRelation(lot, 'fruit', objects?.fruits, 'fruitId');
      const variety = getLotRelation(lot, 'variety', objects?.varieties, 'varietyId');
      const product = getLotRelation(lot, 'product', objects?.products, 'productId');
      const fruitName = fruit?.name || '';
      const varietyName = variety?.name || '';
      const code = product?.code;

      const text = `${fruitName} ${varietyName}${code ? ` (${code})` : ''}`;

      return (
        <Tooltip title={text} placement="top">
          <div>
            <Chip
              icon={<InfoIcon />}
              size="small"
              label={text}
              className={classes.blueChip}
              color="primary"
            />
          </div>
        </Tooltip>
      );
    }
    return null;
  };

  const getChipWeight = (receipt) => {
    const departureLots = getReceiptLots(receipt);
    const text = `${fNumber.format(
      departureLots.reduce((acum, l) => acum + (l?.quantity || 0), 0),
    )} ${unitCode}`;
    return (
      <Tooltip title={text} placement="top">
        <Chip
          icon={<OfflinePinIcon />}
          size="small"
          label={text}
          className={classes.greenChip}
          color="primary"
        />
      </Tooltip>
    );
  };

  const getArrayReceipt = (receipt) => {
    const receiptLot = getReceiptLot(receipt);
    const process = getReceiptProcess(receipt);
    const supplier = getReceiptSupplier(receipt);
    const supplierEntity = getEntityFromOwner(supplier);
    const client = getReceiptClient(receipt);
    const clientEntity = getEntityFromOwner(client);
    const paddock = getPaddockFromReceiptLot(receiptLot);
    const receiptCallOff = receipt?.customFields?.callOff || '-';

    return [
      { value: shouldShowCallOffColumn ? receiptCallOff : receiptLot?.number || '-', icon: <LayersOutlined /> },
      { value: receipt.dispatchOrderNumber || '-', icon: <AssignmentOutlined /> },
      {
        value: (
          <>
            {process?.date ? getLocalDate(process.date).localeDate : '-'}
            <br />
            {process?.date ? getLocalDate(process.date).localeTime : '-'}
          </>
        ),
        icon: <CalendarTodayOutlined />,
      },
      { value: supplierEntity?.name || '-', icon: <LocalShippingOutlined /> },
      { value: getChipProduct(receipt) },
      { value: getChipWeight(receipt) },
      { value: paddock?.name || '-', icon: <HouseOutlined /> },
      { value: clientEntity?.name || '-', icon: <AccountCircleOutlined /> },
      { value: receipt.harvester || '-', icon: <AccountCircleOutlined /> },
      {
        value: receipt.harvestDate ? moment(receipt.harvestDate).format('DD-MM-YYYY') : '-',
        icon: <CalendarTodayOutlined />,
      },
      { value: <Box className="row-options">{getOptions(receipt)}</Box> },
    ];
  };

  return (
    <Grid item xs={12}>
      <Card className={classes.root}>
        <CardContent>
          {truthty(receipts) ? (
            <Grid container spacing={3} className={classes.container}>
              <Grid item xs={12}>
                {loading ? (
                  <SkeletonList times={pagination.rowsPerPage} />
                ) : (
                  <>
                    <Header headerList={headerList} isMobileDevice={isMobileDevice} />
                    {receipts.map((receipt) => (
                      <Row
                        row={getArrayReceipt(receipt)}
                        headerList={headerList}
                        isMobileDevice={isMobileDevice}
                        handleOnClick={() => {}}
                      />
                    ))}
                    {/* <List>
                      {receipts.map((receipt) => ItemMenu(receipt, classes, handleClick))}
                    </List> */}
                  </>
                )}
              </Grid>
              <CustomPagination
                rowsPerPage={pagination.rowsPerPage}
                page={pagination.page}
                count={pagination.count}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                handleChangePage={handleChangePage}
                loading={loading}
              />
              <Menu anchorEl={anchorEl} keepMounted open={truthty(anchorEl)} onClose={handleClose}>
                {canPrint && (
                  <MenuItem onClick={printFnc}>
                    <ListItemIcon>
                      <PrintIcon />
                    </ListItemIcon>
                    {t('receipts.itemList.print')}
                  </MenuItem>
                )}
                {canTraceability && (
                  <MenuItem onClick={toggleTaceability}>
                    <ListItemIcon>
                      <TrendingUpIcon />
                    </ListItemIcon>
                    {t('receipts.itemList.traceability')}
                  </MenuItem>
                )}
                {canEdit && (
                  <MenuItem onClick={toggleEdit}>
                    <ListItemIcon>
                      <EditIcon />
                    </ListItemIcon>
                    {t('receipts.itemList.edit')}
                  </MenuItem>
                )}
                {canDelete && (
                  <MenuItem onClick={toggleDelete}>
                    <ListItemIcon>
                      <DeleteIcon />
                    </ListItemIcon>
                    {t('receipts.itemList.delete')}
                  </MenuItem>
                )}
              </Menu>
            </Grid>
          ) : (
            <Grid container item xs={12} alignItems="center" justifyContent="center">
              <Typography variant="h6" component="h2">
                {t('receipts.itemList.noReceipts')}
              </Typography>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}

const withSaga = connectSaga({ key: 'sagaReceipts', saga });

const withConnect = connect(
  selectState(
    'receipts.receiptIdList',
    'receipts.pagination',
    'receipts.loading',
    'receipts.inputSearch',
    'app.objects',
    'app.device',
    'app.account',
    'app.role',
  ),
  actionProps(
    clone(clone.OBJECT, {
      paginationControls: receiptsActions.paginationControls,
      toggleEdit: receiptsActions.toggleEdit,
      toggleDelete: receiptsActions.toggleDelete,
      printLabel: appActions.printLabel,
      printReceptionLabel: appActions.printReceptionLabel,
    }),
  ),
);

export default compose(withRouter, withConnect)(withSaga(ItemList));
